import React, { Component } from "react";
import { FormControl, InputGroup } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import ObjectUtils from "../../../../utils/ObjectUtils";
import ValidatorUtils from "../../../../utils/ValidatorUtils";
import QuestionHeader from "./QuestionHeader";

const VALIDATORS = "validators";
const PROPS = "props";
const MAX_VALUE = "maxValue";

export default class Upload extends Component {
  onMaxLengthChange(event) {
    const { setValidator, pageName, question } = this.props;
    const validator = ValidatorUtils.sizeMbValidator(event.target.value);
    setValidator(pageName, question.name, validator);
  }

  render() {
    const {
      changeQuestionField,
      pageName,
      question,
      intl,
      loadIndicators,
      addIndicatorToQuestion,
      removeIndicatorFromQuestion,
      allIndicators
    } = this.props;
    const length = ObjectUtils.hasProperty(question, VALIDATORS, 0, PROPS, MAX_VALUE)
      ? question[VALIDATORS][0][PROPS][MAX_VALUE]
      : 10;

    return (
      <QuestionHeader
        changeQuestionField={changeQuestionField}
        pageName={pageName}
        question={question}
        intl={intl}
        addIndicatorToQuestion={addIndicatorToQuestion}
        removeIndicatorFromQuestion={removeIndicatorFromQuestion}
        loadIndicators={loadIndicators}
        allIndicators={allIndicators}
      >
        <InputGroup>
          <InputGroup.Text>
            <FormattedMessage id="survey.editor.text.maxSize" />
          </InputGroup.Text>
          <FormControl type="text" onChange={this.onMaxLengthChange.bind(this)} value={length} />
          <InputGroup.Text>
            <FormattedMessage id="survey.editor.text.mb" />
          </InputGroup.Text>
        </InputGroup>
      </QuestionHeader>
    );
  }
}
